const SSO_REDIRECT_PENDING_KEY = 'sso_redirect_started_at';
const SSO_REDIRECT_MAX_AGE_MS = 10 * 60 * 1000; // 10 minutes

export const markSsoRedirectPending = (): void => {
  if (typeof window === 'undefined') {
    return;
  }
  window.sessionStorage.setItem(SSO_REDIRECT_PENDING_KEY, String(Date.now()));
};

export const clearSsoRedirectPending = (): void => {
  if (typeof window === 'undefined') {
    return;
  }
  window.sessionStorage.removeItem(SSO_REDIRECT_PENDING_KEY);
};

export const isSsoRedirectPending = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const rawValue = window.sessionStorage.getItem(SSO_REDIRECT_PENDING_KEY);
  if (!rawValue) {
    return false;
  }

  const startedAt = Number(rawValue);
  if (!Number.isFinite(startedAt)) {
    clearSsoRedirectPending();
    return false;
  }

  if (Date.now() - startedAt > SSO_REDIRECT_MAX_AGE_MS) {
    clearSsoRedirectPending();
    return false;
  }

  return true;
};

export const getSsoRedirectStartedAt = (): number | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const rawValue = window.sessionStorage.getItem(SSO_REDIRECT_PENDING_KEY);
  if (!rawValue) {
    return null;
  }

  const startedAt = Number(rawValue);
  if (!Number.isFinite(startedAt)) {
    clearSsoRedirectPending();
    return null;
  }

  if (Date.now() - startedAt > SSO_REDIRECT_MAX_AGE_MS) {
    clearSsoRedirectPending();
    return null;
  }

  return startedAt;
};
